import {Cache as AwsCache} from "aws-amplify"
import {isBrowser} from "utils/browser"

/**
 * Due to unresolved issues with Line, using session storage currently
 * causes third-party client redirects to fail. We will re-evaluate switching
 * back to session storage once the issues are resolved.
 */

const KEY_CALLBACK_CLIENT = "-giant-id-callbackClient-id"
const KEY_CALLBACK_CLIENT_URI = "-giant-id-callbackClient-uri"

function initCustomCache() {
  const config = {
    keyPrefix: "aws-amplify-session",
    storage: isBrowser ? window.sessionStorage : undefined,
  }
  return AwsCache.createInstance(config)
}

const Cache = initCustomCache()

/**
 * @param {string} clientId
 * @param {string} callbackUri
 */
export function registerCallbackClient(clientId, callbackUri) {
  Cache.setItem(KEY_CALLBACK_CLIENT, clientId, {
    // expires in an hour (consistent with token expiry)
    expires: Date.now() + 60 * 60 * 1000,
  })
  Cache.setItem(KEY_CALLBACK_CLIENT_URI, callbackUri, {
    // expires in an hour (consistent with token expiry)
    expires: Date.now() + 60 * 60 * 1000,
  })
}

export async function unregisterCallbackClient() {
  Cache.removeItem(KEY_CALLBACK_CLIENT)
  Cache.removeItem(KEY_CALLBACK_CLIENT_URI)
}

/**
 * @returns {{id: string | null, uri: string | null}}
 */
export const getCallbackClient = () => ({
  id: Cache.getItem(KEY_CALLBACK_CLIENT),
  uri: Cache.getItem(KEY_CALLBACK_CLIENT_URI),
})

export const hasCallbackClient = () =>
  !!Cache.getItem(KEY_CALLBACK_CLIENT) &&
  !!Cache.getItem(KEY_CALLBACK_CLIENT_URI)

export const clearAmplifyOAuthState = () => {
  window.sessionStorage.removeItem("oauth_state")
  window.sessionStorage.removeItem("ouath_pkce_key")
}
